<template>
  <div>
    <v-card class="cart" elevation="1">
      <div class="cart-header">
        <div
          class="item cart-button"
          :class="[
            cartSection == 'bet' ? 'active' : 'deactivated',
            getCashout || getCashoutLive ? 'item33' : 'item50'
          ]"
          @click="switchCartSection('bet')"
        >
          {{ $t('bet') }}
          <sup class="num-odds" v-if="getBet.odds.length > 0">{{
            getBet.odds.length
          }}</sup>
        </div>

        <div
          class="item my-bets"
          :class="[
            cartSection == 'myBets' ? 'active' : 'deactivated',
            getCashout || getCashoutLive ? 'item33' : 'item50',
            isTerminalUser ? 'disabled' : ''
          ]"
          @click="!isTerminalUser && switchCartSection('myBets')"
        >
          {{ $t('myBets') }}
        </div>

        <div
          class="item my-bets item33"
          v-if="getCashout || getCashoutLive"
          :class="cartSection == 'myBetsCashout' ? 'active' : 'deactivated'"
          @click="switchCartSection('myBetsCashout')"
        >
          {{ $t('Cashout') }}
        </div>
      </div>
      <div class="cart-content" v-if="cartSection == 'bet'">
        <BetSlip></BetSlip>
      </div>
      <div class="cart-content" v-if="cartSection == 'myBets'">
        <MyBets></MyBets>
      </div>
      <div class="cart-content" v-if="cartSection == 'myBetsCashout'">
        <myBetsCashout></myBetsCashout>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BetSlip from '@/components/right_widgets/BetSlip';
import MyBets from '@/components/right_widgets/MyBets';
import myBetsCashout from '@/components/right_widgets/MyBetsCashout';

export default {
  name: 'Cart',
  components: { MyBets, BetSlip, myBetsCashout },
  data: () => ({
    cartSection: 'bet',
    other: 'item cart-button'
  }),
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getBet: 'cart/getBet',
      getLoading: 'cart/getLoading',
      getCashout: 'settings/getCashout',
      getCashoutLive: 'settings/getCashoutLive',
      isTerminalUser: 'user/isTerminalUser'
    })
  },
  methods: {
    ...mapActions({
      setLoadingCart: 'cart/setLoadingCart'
    }),

    switchCartSection(section) {
      this.cartSection = section;
    }
  },

  mounted() {
    this.$root.$on('sectionCart', () => {
      this.switchCartSection('bet');
    });
  }
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
